import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { GetServerSideProps } from 'next'
import { AllProducts } from 'features/ECommerce/screens/AllProducts'
import { prefetchFetchProducts } from 'features/ECommerce/api/queries/useFetchProducts'

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const dehydratedState = await prefetchFetchProducts({
    page: 1,
    limit: 10,
    proteins: [],
    types: [],
    textSearch: '',
  })

  return {
    props: {
      ...dehydratedState,
    },
  }
}

export default function Products() {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Products - We Feed Raw',
    url: 'https://wefeedraw.com/products',
    description: 'Explore our range of raw pet food products.',
    numberOfItems: 9,
    itemListElement: [
      {
        '@type': 'Product',
        name: 'Big Box',
        url: 'https://wefeedraw.com/products/big-box',
        image: 'https://wefeedraw.com/assets/e-commerce-big-box.png',
        description: 'Perfect for medium-to-large dogs (50 lbs or more). Ideal for feeding as entire meals or bases.',
        brand: {
          '@type': 'Brand',
          name: 'We Feed Raw'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://wefeedraw.com/products/big-box',
          priceCurrency: 'USD',
          price: '264.00',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD'
            },
            shippingDestination: {
              '@type': 'DefinedRegion',
              name: 'Worldwide'
            }
          }
        }
      },
      {
        '@type': 'Product',
        name: 'Classic Box',
        url: 'https://wefeedraw.com/products/classic-box',
        image: 'https://wefeedraw.com/assets/e-commerce-classic-box.png',
        description: 'Perfect for medium-size dogs. Ideal for feeding as a base or an entire meal to one dog or multiple dogs of different sizes.',
        brand: {
          '@type': 'Brand',
          name: 'We Feed Raw'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://wefeedraw.com/products/classic-box',
          priceCurrency: 'USD',
          price: '199.00',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD'
            },
            shippingDestination: {
              '@type': 'DefinedRegion',
              name: 'Worldwide'
            }
          }
        }
      },
      {
        '@type': 'Product',
        name: 'Small Box',
        url: 'https://wefeedraw.com/products/small-box',
        image: 'https://wefeedraw.com/assets/e-commerce-small-box.png',
        description: 'Perfect for small dogs (or as a taste-test for larger dogs).',
        brand: {
          '@type': 'Brand',
          name: 'We Feed Raw'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://wefeedraw.com/products/small-box',
          priceCurrency: 'USD',
          price: '132.00',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD'
            },
            shippingDestination: {
              '@type': 'DefinedRegion',
              name: 'Worldwide'
            }
          }
        }
      },
      {
        '@type': 'Product',
        name: '5lb Venison Patty Recipe',
        url: 'https://wefeedraw.com/products/5-lb-venison-patty-recipe',
        image: 'https://wefeedraw.com/assets/e-commerce-venison.png',
        description: 'Complete & Balanced nutrition for dogs of all life stages.',
        brand: {
          '@type': 'Brand',
          name: 'We Feed Raw'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://wefeedraw.com/products/5-lb-venison-patty-recipe',
          priceCurrency: 'USD',
          price: '49.99',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD'
            },
            shippingDestination: {
              '@type': 'DefinedRegion',
              name: 'Worldwide'
            }
          }
        }
      },
      {
        '@type': 'Product',
        name: '5lb Lamb Patty Recipe',
        url: 'https://wefeedraw.com/products/5-lb-lamb-patty-recipe',
        image: 'https://wefeedraw.com/assets/e-commerce-lamb.png',
        description: 'Complete & Balanced nutrition for dogs of all life stages.',
        brand: {
          '@type': 'Brand',
          name: 'We Feed Raw'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://wefeedraw.com/products/5-lb-lamb-patty-recipe',
          priceCurrency: 'USD',
          price: '47.99',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD'
            },
            shippingDestination: {
              '@type': 'DefinedRegion',
              name: 'Worldwide'
            }
          }
        }
      },
      {
        '@type': 'Product',
        name: '5lb Duck Patty Recipe',
        url: 'https://wefeedraw.com/products/5-lb-duck-patty-recipe',
        image: 'https://wefeedraw.com/assets/e-commerce-duck.png',
        description: 'Complete & Balanced nutrition for dogs of all life stages.',
        brand: {
          '@type': 'Brand',
          name: 'We Feed Raw'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://wefeedraw.com/products/5-lb-duck-patty-recipe',
          priceCurrency: 'USD',
          price: '47.99',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD'
            },
            shippingDestination: {
              '@type': 'DefinedRegion',
              name: 'Worldwide'
            }
          }
        }
      },
      {
        '@type': 'Product',
        name: '5lb Turkey Patty Recipe',
        url: 'https://wefeedraw.com/products/5-lb-turkey-patty-recipe',
        image: 'https://wefeedraw.com/assets/e-commerce-turkey.png',
        description: 'Complete & Balanced nutrition for dogs of all life stages.',
        brand: {
          '@type': 'Brand',
          name: 'We Feed Raw'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://wefeedraw.com/products/5-lb-turkey-patty-recipe',
          priceCurrency: 'USD',
          price: '42.99',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD'
            },
            shippingDestination: {
              '@type': 'DefinedRegion',
              name: 'Worldwide'
            }
          }
        }
      },
      {
        '@type': 'Product',
        name: '5lb Beef Patty Recipe',
        url: 'https://wefeedraw.com/products/5-lb-beef-patty-recipe',
        image: 'https://wefeedraw.com/assets/e-commerce-beef.png',
        description: 'Complete & Balanced nutrition for dogs of all life stages.',
        brand: {
          '@type': 'Brand',
          name: 'We Feed Raw'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://wefeedraw.com/products/5-lb-beef-patty-recipe',
          priceCurrency: 'USD',
          price: '42.99',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD'
            },
            shippingDestination: {
              '@type': 'DefinedRegion',
              name: 'Worldwide'
            }
          }
        }
      },
      {
        '@type': 'Product',
        name: '5lb Chicken Patty Recipe',
        url: 'https://wefeedraw.com/products/5-lb-chicken-patty-recipe',
        image: 'https://wefeedraw.com/assets/e-commerce-chicken.png',
        description: 'Complete & Balanced nutrition for dogs of all life stages.',
        brand: {
          '@type': 'Brand',
          name: 'We Feed Raw'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://wefeedraw.com/products/5-lb-chicken-patty-recipe',
          priceCurrency: 'USD',
          price: '37.99',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD'
            },
            shippingDestination: {
              '@type': 'DefinedRegion',
              name: 'Worldwide'
            }
          }
        }
      }
    ]
  };

  const jsonLdString = JSON.stringify(schema)

  return (
    <div>
      <Head>
        <title>{t('e-commerce:page-title')}</title>
        <meta name="title" content={t('e-commerce:meta-title')} />
        <meta name="description" content={t('e-commerce:meta-description')} />
        <link rel="canonical" href="https://wefeedraw.com/products" />
        <div
          dangerouslySetInnerHTML={{
            __html: `<script type="application/ld+json">${jsonLdString}</script>`,
          }}
        />
      </Head>

      <main>
        <AllProducts />
      </main>
    </div>
  )
}
